/**
 * SIZE CHART — Auto-detect product type, measurement table, CM/IN toggle, recommender
 */
(function () {
  'use strict';

  var CM_TO_IN = 0.393701;

  /* ---- Helpers ---- */
  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  function roundTo(val, decimals) {
    var f = Math.pow(10, decimals);
    return Math.round(val * f) / f;
  }

  /* ---- Web Component ---- */
  var SizeChartRecommender = function () {
    return Reflect.construct(HTMLElement, [], SizeChartRecommender);
  };
  SizeChartRecommender.prototype = Object.create(HTMLElement.prototype);
  SizeChartRecommender.prototype.constructor = SizeChartRecommender;

  SizeChartRecommender.prototype.connectedCallback = function () {
    this._productTitle = this.getAttribute('product-title') || '';
    this._configUrl = this.getAttribute('config-url');
    if (!this._configUrl) return;

    /* Read saved unit preference */
    try {
      this._unit = localStorage.getItem('size-unit') || 'cm';
    } catch (e) {
      this._unit = 'cm';
    }

    this._init();
  };

  SizeChartRecommender.prototype._init = function () {
    var self = this;
    fetch(this._configUrl)
      .then(function (r) {
        return r.json();
      })
      .then(function (config) {
        var type = self._detectType(config);
        if (!type) {
          self.innerHTML = '';
          return;
        }
        self._type = type;
        self._render();

        /* Show standalone trigger button if linked via data-trigger-for */
        var triggerFor = self.getAttribute('data-trigger-for');
        if (triggerFor) {
          var triggerBtn = document.querySelector('.sc-trigger[aria-controls="' + triggerFor + '"]');
          if (triggerBtn) triggerBtn.hidden = false;
        }
      })
      .catch(function (err) {
        console.warn('[size-chart] Init error:', err);
      });
  };

  SizeChartRecommender.prototype._detectType = function (config) {
    var title = this._productTitle.toLowerCase();
    var types = (config.product_types || []).slice();

    /* Sort by longest pattern first */
    types.sort(function (a, b) {
      var aMax = 0;
      var bMax = 0;
      (a.title_patterns || []).forEach(function (p) {
        if (p.length > aMax) aMax = p.length;
      });
      (b.title_patterns || []).forEach(function (p) {
        if (p.length > bMax) bMax = p.length;
      });
      return bMax - aMax;
    });

    for (var i = 0; i < types.length; i++) {
      var patterns = types[i].title_patterns || [];
      for (var j = 0; j < patterns.length; j++) {
        if (title.indexOf(patterns[j].toLowerCase()) !== -1) {
          return types[i];
        }
      }
    }
    return null;
  };

  SizeChartRecommender.prototype._render = function () {
    var type = this._type;
    var html = '<div class="size-chart">';

    /* --- Section 1: Size Chart Table --- */
    html += '<div class="sc-section">';
    html += '<div class="sc-section-header">';
    html +=
      '<h4 class="sc-section-title">' +
      '<svg width="16" height="16" viewBox="0 0 18 18" fill="none"><rect x="1" y="5" width="16" height="8" rx="1.5" stroke="currentColor" stroke-width="1.4"/><path d="M4 5v3M7 5v2M10 5v3M13 5v2M16 5v1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
      ' SIZE CHART</h4>';
    html += this._buildUnitToggle();
    html += '</div>';
    html += this._buildTable();
    if (type.fit_note) {
      html +=
        '<div class="sc-fit-note">' + esc(type.fit_note) + '</div>';
    }
    html += '</div>';

    /* --- Section 2: Find Your Size --- */
    if (type.recommender) {
      html += '<div class="sc-section">';
      html +=
        '<h4 class="sc-section-title">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
        ' FIND YOUR SIZE</h4>';
      if (type.measurement_guide) {
        html +=
          '<div class="sc-guide">' +
          esc(type.measurement_guide) +
          '</div>';
      }
      html += this._buildRecommenderInput();
      html += '<div class="sc-result"></div>';
      html += '</div>';
    }

    html += '</div>';
    this.innerHTML = html;

    /* Wire up events */
    this._setupEvents();
  };

  SizeChartRecommender.prototype._buildUnitToggle = function () {
    var cmActive = this._unit === 'cm' ? ' sc-unit-btn--active' : '';
    var inActive = this._unit === 'in' ? ' sc-unit-btn--active' : '';
    return (
      '<div class="sc-unit-toggle">' +
      '<button class="sc-unit-btn' +
      cmActive +
      '" data-unit="cm" aria-pressed="' +
      (this._unit === 'cm') +
      '">CM</button>' +
      '<button class="sc-unit-btn' +
      inActive +
      '" data-unit="in" aria-pressed="' +
      (this._unit === 'in') +
      '">IN</button>' +
      '</div>'
    );
  };

  SizeChartRecommender.prototype._buildTable = function () {
    var type = this._type;
    var columns = type.columns || [];
    var sizes = type.sizes || [];
    var unit = this._unit;

    var html = '<div class="sc-table-wrap"><table class="sc-table"><thead><tr>';
    html += '<th>Size</th>';
    columns.forEach(function (col) {
      var label = col.label;
      if (unit === 'in' && col.unit === 'cm') {
        label = label.replace(/\(cm\)/i, '(in)');
      }
      html += '<th>' + esc(label) + ' (' + unit + ')</th>';
    });
    html += '</tr></thead><tbody>';

    sizes.forEach(function (size) {
      html += '<tr><td><strong>' + esc(size.label) + '</strong></td>';
      columns.forEach(function (col) {
        var val = size[col.key];
        if (val != null && unit === 'in' && col.unit === 'cm') {
          val = roundTo(val * CM_TO_IN, 1);
        }
        html += '<td>' + (val != null ? val : '-') + '</td>';
      });
      html += '</tr>';
    });

    html += '</tbody></table></div>';
    return html;
  };

  SizeChartRecommender.prototype._buildRecommenderInput = function () {
    var rec = this._type.recommender;
    var suffix = this._unit;
    var placeholder = this._unit === 'cm' ? 'e.g. 57' : 'e.g. 22.4';

    return (
      '<div class="sc-input-row">' +
      '<div class="sc-input-field">' +
      '<input type="number" class="sc-input" placeholder="' +
      placeholder +
      '" step="0.1" min="0" aria-label="' +
      esc(rec.input_label) +
      '">' +
      '<span class="sc-input-suffix">' +
      suffix +
      '</span>' +
      '</div>' +
      '<button class="sc-find-btn" type="button">Find My Size</button>' +
      '</div>'
    );
  };

  SizeChartRecommender.prototype._setupEvents = function () {
    var self = this;

    /* Unit toggle */
    var toggleBtns = this.querySelectorAll('.sc-unit-btn');
    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var newUnit = btn.getAttribute('data-unit');
        if (newUnit === self._unit) return;
        self._unit = newUnit;
        try {
          localStorage.setItem('size-unit', newUnit);
        } catch (e) {
          /* silent */
        }
        self._render();
      });
    });

    /* Find button */
    var findBtn = this.querySelector('.sc-find-btn');
    var input = this.querySelector('.sc-input');
    if (findBtn && input) {
      findBtn.addEventListener('click', function () {
        self._recommend();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          self._recommend();
        }
      });
    }
  };

  SizeChartRecommender.prototype._recommend = function () {
    var input = this.querySelector('.sc-input');
    var resultEl = this.querySelector('.sc-result');
    if (!input || !resultEl) return;

    var rawVal = parseFloat(input.value);
    if (isNaN(rawVal) || rawVal <= 0) {
      resultEl.innerHTML = '';
      return;
    }

    /* Convert to cm if needed */
    var valCm = this._unit === 'in' ? rawVal / CM_TO_IN : rawVal;
    var rec = this._type.recommender;
    var ranges = rec.fit_ranges || [];

    var result = this._findFit(valCm, ranges, rec);
    resultEl.innerHTML = this._buildResultCard(result, rawVal);
  };

  SizeChartRecommender.prototype._findFit = function (valCm, ranges, rec) {
    /* Direct match */
    for (var i = 0; i < ranges.length; i++) {
      var r = ranges[i];
      if (valCm >= r.min_cm && valCm <= r.max_cm) {
        var center = (r.min_cm + r.max_cm) / 2;
        var halfRange = (r.max_cm - r.min_cm) / 2;
        var distance = Math.abs(valCm - center);
        var ratio = halfRange > 0 ? distance / halfRange : 0;

        var quality;
        if (ratio <= 0.5) quality = 'comfortable';
        else if (ratio <= 0.8) quality = 'snug';
        else quality = 'tight';

        return { size: r.size, quality: quality };
      }
    }

    /* Below all ranges */
    if (ranges.length > 0 && valCm < ranges[0].min_cm) {
      return { size: ranges[0].size, quality: 'snug' };
    }

    /* Above all ranges */
    if (ranges.length > 0 && valCm > ranges[ranges.length - 1].max_cm) {
      return { size: ranges[ranges.length - 1].size, quality: 'tight' };
    }

    /* Between ranges — pick next size up */
    for (var j = 0; j < ranges.length - 1; j++) {
      if (valCm > ranges[j].max_cm && valCm < ranges[j + 1].min_cm) {
        return { size: ranges[j + 1].size, quality: 'snug' };
      }
    }

    /* Fallback */
    return { size: rec.default_size || 'OSFM', quality: 'comfortable' };
  };

  SizeChartRecommender.prototype._buildResultCard = function (result, rawVal) {
    var q = result.quality;
    var qLabel, qDesc, checkSvg;

    if (q === 'comfortable') {
      qLabel = 'Comfortable Fit';
      qDesc = 'great, comfortable fit';
      checkSvg =
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    } else if (q === 'snug') {
      qLabel = 'Snug Fit';
      qDesc = 'snug, secure fit';
      checkSvg =
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 9v4M12 17h.01"/></svg>';
    } else {
      qLabel = 'Tight Fit';
      qDesc = 'tight fit \u2014 consider sizing up if possible';
      checkSvg =
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 9v4M12 17h.01"/></svg>';
    }

    var displayVal = roundTo(rawVal, 1) + ' ' + this._unit;

    return (
      '<div class="sc-result-card sc-result-card--' +
      q +
      '">' +
      '<div class="sc-result-top">' +
      '<div class="sc-result-size">' +
      '<span class="sc-result-size__label">We recommend</span>' +
      '<span class="sc-result-size__value">Size ' +
      esc(result.size) +
      '</span>' +
      '</div>' +
      '<span class="sc-result-fit sc-result-fit--' +
      q +
      '">' +
      checkSvg +
      ' ' +
      qLabel +
      '</span>' +
      '</div>' +
      '<div class="sc-result-body">' +
      '<p>Based on your measurement of <strong>' +
      esc(displayVal) +
      '</strong>, we recommend <strong>Size ' +
      esc(result.size) +
      '</strong>.</p>' +
      '<p>This size will give you a <strong>' +
      qDesc +
      '</strong>.</p>' +
      '</div>' +
      '</div>'
    );
  };

  customElements.define('size-chart-recommender', SizeChartRecommender);
})();
